export const getFileReader = async (file) => new Promise(resolve => {
    const fr = new FileReader();
    fr.onload = () => {
        resolve({ url: fr.result });
    };
    fr.readAsDataURL(file);
});
//# sourceMappingURL=filereader.js.map